"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessCodeJsonMapper = exports.AccessCodeDynamoMapper = exports.AccessCodeByCodeIndex = void 0;
var access_code_dynamodb_1 = require("./access-code-dynamodb");
Object.defineProperty(exports, "AccessCodeByCodeIndex", { enumerable: true, get: function () { return access_code_dynamodb_1.AccessCodeByCodeIndex; } });
Object.defineProperty(exports, "AccessCodeDynamoMapper", { enumerable: true, get: function () { return access_code_dynamodb_1.AccessCodeDynamoMapper; } });
var access_code_json_1 = require("./access-code-json");
Object.defineProperty(exports, "AccessCodeJsonMapper", { enumerable: true, get: function () { return access_code_json_1.AccessCodeJsonMapper; } });
